export interface ITag {
  id: number;
  name: string;
}

export enum EntityType {
  PRODUCT = 'PRODUCT',
}
